import { Box, styled } from "@mui/material";
import React, { PropsWithChildren } from "react";
import SiderBar from "../components/sidebar";
import { MobileDrawerScreen, MobileHeaderScreen } from ".";

const Layout: React.FC<
  PropsWithChildren<{
    children: React.ReactNode;
  }>
> = ({ children }) => {
  return (
    <>
      <MobileDrawerWrapper>
        <MobileDrawerScreen />
      </MobileDrawerWrapper>
      <MainBox>
        <SidebarNav>
          <SiderBar />
        </SidebarNav>

        {/* main section */}
        <div>
          <MobileHeaderScreen />
          <RightMainSection>{children}</RightMainSection>
        </div>
      </MainBox>
    </>
  );
};

export default Layout;

const MainBox = styled(Box)`
  background-color: #f7f7f7;
  display: flex;
  height: 100vh;
  width: 100vw;
`;

const SidebarNav = styled("nav")`
  width: 70px;
  background-color: var(--primary);
  position: fixed;
  left: 0;
  height: 100%;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    display: none;
  }
`;

const RightMainSection = styled("main")`
  height: 100%;
  overflow-y: auto;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: calc(100vw - 70px);
    margin-left: 70px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 100vw;
  }
`;
const MobileDrawerWrapper = styled("section")`
  ${({ theme }) => theme.breakpoints.up("sm")} {
    display: none;
  }
`;
